import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';
import {
  IrrigationOptimizationChartWithPlantationViewModel,
  IrrigationRecommendationViewModel,
} from '@/app/proxy/proxies';
import { SafeImageDirective } from '@/app/shared/directives/safe-image.directive';

@Component({
  selector: 'dk-home-plantation-select',
  imports: [SharedModule, SafeImageDirective],
  templateUrl: './dk-select-plantation.component.html',
  styleUrl: './dk-select-plantation.component.less',
})
export class DkSelectPlantationComponent implements OnInit, OnChanges {
  @Input() selectablePlantations:
    | IrrigationOptimizationChartWithPlantationViewModel[]
    | IrrigationRecommendationViewModel[] = [];
  @Input() selectedPlantation:
    | IrrigationOptimizationChartWithPlantationViewModel
    | IrrigationRecommendationViewModel
    | null = null;
  @Output() onSelectPlantation = new EventEmitter<
    IrrigationOptimizationChartWithPlantationViewModel | IrrigationRecommendationViewModel
  >();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedPlantation']) {
      this.selectedPlantation = changes['selectedPlantation'].currentValue;
    }
  }

  ngOnInit(): void {
    if (this.selectedPlantation == null && this.selectablePlantations?.length > 0) {
      this.onSelect(this.selectablePlantations[0]);
    }
  }

  onSelect(plantation: IrrigationOptimizationChartWithPlantationViewModel | IrrigationRecommendationViewModel) {
    this.selectedPlantation = plantation;
    this.onSelectPlantation.emit(plantation);
  }
}
